<template>
  <div>
    <div>
      <CustomLoader v-if="isLoading" :width="70"></CustomLoader>
    </div>
    <b-card class="mainCardBG">
      <b-card-text>
        <b-row>
          <b-col md="4" class="my-1">
            <b-navbar-nav>
              <b-button @click="goBack" size="sm" class="ml-2 mr-2" variant="outline-secondary"
                style="font-size: 0.675rem">
                <md-icon icon="gear-fill" aria-hidden="true">skip_previous</md-icon>Back
              </b-button>
            </b-navbar-nav>
            <h5 class="mt-1 mr-2">
              {{ $route.name }}
            </h5>
          </b-col>
          <b-col md="2">
            <h5>
              <small v-if="isLoading == false">{{ totalData }} Entries</small>
            </h5>
          </b-col>
          <b-col md="6">
            <b-button class="pull-right ml-1 mt-1" :variant="Filter.DateTypeFilter ||
              Filter.JobNoFilter ||
              Filter.clientFilter ||
              Filter.slineFilter ||
              Filter.TransportTypeFilter ||
              Filter.ShipemntTypeFilter ||
              Filter.PORFilter ||
              Filter.POLFilter ||
              Filter.PODFilter ||
              Filter.FPODFilter ||
              Filter.statusFilter ||
              Filter.commonFilter ||
              Filter.createdByFilter ||
              Filter.branchFilter ||
              Filter.dateRange.startDate ||
              Filter.dateRange.endDate
              ? 'outline-danger'
              : 'outline-primary'
              " :class="' ml-4' + visible ? null : 'collapsed'" :aria-expanded="visible ? 'true' : 'false'"
              aria-controls="collapse-4" @click="visible = !visible" style="font-size: 0.675rem">{{
                Filter.DateTypeFilter ||
                  Filter.JobNoFilter ||
                  Filter.clientFilter ||
                  Filter.slineFilter ||
                  Filter.TransportTypeFilter ||
                  Filter.ShipemntTypeFilter ||
                  Filter.PORFilter ||
                  Filter.POLFilter ||
                  Filter.PODFilter ||
                  Filter.FPODFilter ||
                  Filter.statusFilter ||
                  Filter.commonFilter ||
                  Filter.createdByFilter ||
                  Filter.branchFilter ||
                  Filter.dateRange.startDate ||
                  Filter.dateRange.endDate
                  ? "Filter ON"
                  : "Filter OFF"
              }}</b-button>
            <b-button class="pull-right ml-1 mt-1" v-if="getPaymentList.length > 0"
              :disabled="ExcelBtnName != 'Export As Excel' ? true : false"
              @click="getReports('getPaymentList', 'Export As Excel')" size="sm" variant="warning"
              style="font-size: 0.675rem">
              {{ ExcelBtnName }}
              <b-spinner v-if="ExcelBtnName != 'Export As Excel'" small label="Small Spinner"></b-spinner></b-button>

            <b-button class="pull-right ml-1 mt-1" v-if="getPaymentList.length > 0"
              :disabled="ExcelBtnName1 != 'Export And Import' ? true : false"
              @click="getExpImpReports('getPaymentList', 'Export And Import')" size="sm" variant="warning"
              style="font-size: 0.675rem">
              {{ ExcelBtnName1 }}
              <b-spinner v-if="ExcelBtnName1 != 'Export And Import'" small label="Small Spinner"></b-spinner></b-button>
            <b-form-group class="pull-right ml-1 mt-1">
              <b-button variant="primary" class="d-flex align-items-center" size="sm" style="font-size: 0.675rem"
                @click="triggerFileInput">
                <md-icon class="md-size-1x nav-icon mr-2">cloud_upload</md-icon>

                <div v-if="isFileLoading" class="d-flex align-items-center">
                  <span class="mr-2">Uploading...</span>
                  <b-spinner small></b-spinner>
                </div>
                <div v-else class="d-flex align-items-center">
                  Upload File
                </div>
              </b-button>
              <input ref="fileInput" type="file" class="d-none" @change="handleFileUpload" accept=".xlsx, .xls" />
            </b-form-group>
          </b-col>

          <b-col cols="12">
            <div>
              <b-pagination limit="25" align="center" v-model="pagination.currentPage" :per-page="pagination.perPage"
                :total-rows="totalData" @change="onPageChange($event)"></b-pagination>
            </div>
          </b-col>

          <b-col md="3">
            <label>Date Type</label>
            <model-list-select :list="dateTypeList" v-model="Filter.DateTypeFilter" option-value="value"
              option-text="text" placeholder="Select Date Type"
              @input="getBulkSlinePaymentList('Normal', '0', '0', '1', '1')"></model-list-select>
          </b-col>
          <b-col md="3">
            <label>Date</label>
            <date-range-picker :always-show-calendars="showCal" v-model="Filter.dateRange" :startDate="startDate"
              :endDate="endDate" :locale-data="locale" :disabled="Filter.DFlag ? true : false"
              @update="getBulkSlinePaymentList('Normal', '0', '0', '1', '1')"></date-range-picker>
          </b-col>
          <b-col md="3">
            <label>Shipping Line</label>
            <model-list-select :list="$store.getters['common/getAllShippingLineList']" v-model="Filter.slineFilter"
              option-value="shippingId" option-text="shippingLine" placeholder="Select Shipping Line"
              @input="getBulkSlinePaymentList('Normal', '0', '0', '1', '1')"></model-list-select>
          </b-col>


        </b-row>
        <div v-if="visible">
          <b-card>
            <b-collapse v-model="visible" id="collapse-2">
              <b-row>
                <b-col md="3">
                  <label>Date Type</label>
                  <model-list-select :list="dateTypeList" v-model="Filter.DateTypeFilter" option-value="value"
                    option-text="text" placeholder="Select Date Type"
                    @input="getBulkSlinePaymentList('Normal', '0', '0', '1', '1')"></model-list-select>
                </b-col>
                <b-col md="3">
                  <label>Date</label>
                  <date-range-picker :always-show-calendars="showCal" v-model="Filter.dateRange" :startDate="startDate"
                    :endDate="endDate" :locale-data="locale" :disabled="Filter.DFlag ? true : false"
                    @update="getBulkSlinePaymentList('Normal', '0', '0', '1', '1')"></date-range-picker>
                </b-col>
                <b-col md="3">
                  <label>Job NO Filter</label>
                  <b-form-input type="text" :formatter="capitalizeAll" placeholder="Search Job NO Filter"
                    id="JobNoFilter" name="JobNoFilter" autocomplete="off" v-model="Filter.JobNoFilter"
                    @input="getBulkSlinePaymentList('Normal', '0', '0', '1', '1')"></b-form-input>
                </b-col>
                <b-col md="3">
                  <label>Transport Type</label>
                  <model-list-select :list="transportTypeList" v-model="Filter.TransportTypeFilter" option-value="value"
                    option-text="value" placeholder="Select Transport Type"
                    @input="getBulkSlinePaymentList('Normal', '0', '0', '1', '1')"></model-list-select>
                </b-col>

                <b-col md="3">
                  <label>Shipment Type</label>
                  <model-list-select :list="shipmentTypeList" v-model="Filter.ShipemntTypeFilter" option-value="value"
                    option-text="value" placeholder="Select Shipment Type"
                    @input="getBulkSlinePaymentList('Normal', '0', '0', '1', '1')"></model-list-select>
                </b-col>

                <b-col md="3">
                  <label>Shipping Line</label>
                  <model-list-select :list="$store.getters['common/getAllShippingLineList']"
                    v-model="Filter.slineFilter" option-value="shippingId" option-text="shippingLine"
                    placeholder="Select Shipping Line"
                    @input="getBulkSlinePaymentList('Normal', '0', '0', '1', '1')"></model-list-select>
                </b-col>
                <b-col md="3">
                  <label>Client</label>
                  <model-list-select :list="$store.getters['common/getAllClientList']" id="clientFilter"
                    v-model="Filter.clientFilter" option-value="clientId" option-text="clientName"
                    placeholder="Select Client Name"
                    @input="getBulkSlinePaymentList('Normal', '0', '0', '1', '1')"></model-list-select>
                </b-col>
                <b-col md="3">
                  <label>Branch</label>
                  <model-list-select :list="$store.getters['common/getAllBranchList']" id="branchfilter"
                    v-model="Filter.branchFilter" option-value="pickupId" option-text="pickupLocation" placeholder="All"
                    @input="getBulkSlinePaymentList('Normal', '0', '0', '1', '1')"></model-list-select>
                </b-col>

                <b-col md="3">
                  <label>POR</label>
                  <model-list-select :list="$store.getters['common/getAllPORList']" id="PORFilter"
                    v-model="Filter.PORFilter" option-value="pickupId" option-text="pickupLocation" placeholder="All"
                    @input="getBulkSlinePaymentList('Normal', '0', '0', '1', '1')"></model-list-select>
                </b-col>
                <b-col md="3">
                  <label>POL</label>
                  <model-list-select :list="$store.getters['common/getAllPOLList']" id="POLFilter"
                    v-model="Filter.POLFilter" option-value="pickupId" option-text="pickupLocation" placeholder="All"
                    @input="getBulkSlinePaymentList('Normal', '0', '0', '1', '1')"></model-list-select>
                </b-col>
                <b-col md="3">
                  <label>POD</label>
                  <model-list-select :list="$store.getters['common/getAllPODList']" id="PODFilter"
                    v-model="Filter.PODFilter" option-value="pickupId" option-text="pickupLocation" placeholder="All"
                    @input="getBulkSlinePaymentList('Normal', '0', '0', '1', '1')"></model-list-select>
                </b-col>
                <b-col md="3">
                  <label>FPOD</label>
                  <model-list-select :list="$store.getters['common/getAllLocationDetailsFinalList']" id="FPODFilter"
                    v-model="Filter.FPODFilter" option-value="pickupId" option-text="pickupLocation" placeholder="All"
                    @input="getBulkSlinePaymentList('Normal', '0', '0', '1', '1')"></model-list-select>
                </b-col>

                <b-col md="3">
                  <label>Common Filter</label>
                  <b-form-input type="text" :formatter="capitalizeAll" placeholder="Search Common Filter"
                    id="commonFilter" name="commonFilter" autocomplete="off" v-model="Filter.commonFilter"
                    @input="getBulkSlinePaymentList('Normal', '0', '0', '1', '1')"></b-form-input>
                </b-col>

                <b-col md="3">
                  <label>
                    <b> Created User </b>
                  </label>
                  <model-list-select :list="$store.getters['common/getAllUserList']" id="createdByFilter"
                    @input="getBulkSlinePaymentList('Normal', '0', '0', '1', '1')" v-model="Filter.createdByFilter"
                    option-value="userId" option-text="employeeName"
                    placeholder="Select Created User"></model-list-select>
                </b-col>

                <b-col md="12" class="mt-2">
                  <b-button size="sm" style="margin-left: auto" class="ml-1 pull-right" @click="clearFilter"
                    variant="outline-danger">Reset</b-button>
                </b-col>
              </b-row>
            </b-collapse>
          </b-card>
        </div>
        <div class="row">
          <div class="col-md-12">
            <div class="d-flex align-items-center gap-2">
              <b-form-checkbox :checked="allSelected" @change="toggleSelectAll($event)" />
              <b-button variant="primary" @click="openConfirmModal(selectedCheckBoxRows)" class="btn-sm"
                :disabled="selectedCheckBoxRows.length <= 0">
                Bulk Payment
              </b-button>
            </div>
            <div class="table-responsive tableMain gutr">
              <b-table show-empty stacked="md" responsive :items="getPaymentList" :fields="PaymentFields"
                primary-key="id_email_section" :per-page="pagination.perPage" :filter="filter" :sort-by.sync="sortBy"
                :sort-desc.sync="sortDesc" :sort-direction="sortDirection" @filtered="onFiltered"
                class="position-relative">


                <template slot="checkbox" slot-scope="row0">
                  <div class="d-flex align-items-center gap-2">
                    <b-button @click="row0.toggleDetails" class="mr-2" size="sm" style="font-size: 0.675rem"
                      variant="outline-info">
                      <md-icon>{{ row0.detailsShowing ? "expand_less" : "expand_more" }}</md-icon>
                      {{ row0.detailsShowing ? "Hide More" : "Show More" }}
                      Details
                    </b-button>

                    <b-form-checkbox v-model="selectedCheckBoxRows" :value="{
                      paymentModuleType: row0.item.paymentModuleType,
                      invoicePayID: row0.item.invoicePayID,
                      invoiceID: row0.item.invoiceID,
                      invoiceAmtID: row0.item.invoiceAmtID,
                      JobId: row0.item.JobId,
                      JobNo: row0.item.JobNo,
                      InvNumber: row0.item.invoiceNumber,
                      InvAmt: row0.item.amount,
                    }" />
                  </div>
                </template>
                <template slot="SN" slot-scope="row0">
                  <span>
                    {{
                      row0.index + 1 + (pagination.currentPage - 1) * pagination.perPage
                    }}
                  </span>
                </template>

                <template slot="invoiceNumber" slot-scope="row1">
                  <strong>Inv No:</strong>{{ row1.item.invoiceNumber }}<br />
                  <strong>Inv Date:</strong> {{ row1.item.paymentCreatedDate }}<br />
                  <strong>Inv Amt:</strong> {{ row1.item.amount }}<br />
                  <!-- <strong>Inv Type:</strong>{{ row1.item.invoiceType }}<br />
                  <strong>Inv Category:</strong>{{ row1.item.invoiceCategory }}<br />
                  <strong>Inv Currency:</strong> {{ row1.item.currency }}<br />
                  <strong>Inv Bl No:</strong> {{ row1.item.slineBlNo }}<br />
                  <strong>Due Date:</strong> {{ row1.item.dueDate }}<br />
                  <strong>Sob Date:</strong> {{ row1.item.sobDate }}<br />
                  <strong>Inv Created By:</strong> {{ row1.item.paymentCreatedBy }}<br /> -->
                </template>

                <template slot="JobNo" slot-scope="row1">
                  <strong>Job No:</strong> {{ row1.item.JobNo }}<br />
                  <strong>Job Date:</strong> {{ row1.item.JobDate }}<br />
                </template>

                <template slot="ClientName" slot-scope="row1">
                  <strong>Sline Name:</strong> {{ row1.item.SlineName }}<br />
                  <strong>Client:</strong> {{ row1.item.ClientName }}<br />
                </template>

                <template slot="POR" slot-scope="row1">
                  <strong>POR:</strong> {{ row1.item.POR }}<br />
                  <strong>POL:</strong> {{ row1.item.POL }}<br />

                </template>

                <template slot="EnqNo" slot-scope="row1">
                  <strong>Enq No:</strong> {{ row1.item.EnqNo }}<br />
                  <strong>Enq Date:</strong> {{ row1.item.EnqDate }}<br />
                </template>

                <!-- Expandable Row for Additional Details -->

                <template slot="row-details" slot-scope="row4">
                  <b-card style="background: whiteSmoke">
                    <b-row>
                      <b-col md="3" class="mb-2" v-if="row4.item.invoiceType">
                        <span><b>Inv Type:</b> {{ row4.item.invoiceType }}</span>
                      </b-col>
                      <b-col md="3" class="mb-2" v-if="row4.item.invoiceCategory">
                        <span><b>Inv Category :</b> {{ row4.item.invoiceCategory }}<br /></span>
                      </b-col>
                      <b-col md="3" class="mb-2" v-if="row4.item.currency">
                        <span><b>Inv Currency :</b> {{ row4.item.currency }}<br /></span>
                      </b-col>
                      <b-col md="3" class="mb-2" v-if="row4.item.slineBlNo">
                        <span><b>Inv Bl No :</b> {{ row4.item.slineBlNo }}<br /></span>
                      </b-col>
                      <b-col md="3" class="mb-2" v-if="row4.item.dueDate">
                        <span><b>Due Date :</b> {{ row4.item.dueDate }}<br /></span>
                      </b-col>
                      <b-col md="3" class="mb-2" v-if="row4.item.sobDate"><span><b>Sob Date :</b> {{
                        row4.item.sobDate }}<br /></span></b-col>
                      <b-col md="3" class="mb-2" v-if="row4.item.paymentCreatedBy"><span><b>Inv Created By :</b>
                          {{ row4.item.paymentCreatedBy }}<br /></span></b-col>
                      <b-col md="3" class="mb-2" v-if="row4.item.JobType"><span><b>Job Type :</b>{{
                        row4.item.JobType }}<br /></span></b-col>
                      <b-col md="3" class="mb-2" v-if="row4.item.JobTransportType">
                        <span><b>Transport Type:</b> {{ row4.item.JobTransportType }}</span>
                      </b-col>
                      <b-col md="3" class="mb-2" v-if="row4.item.JobTContainerType">
                        <span><b>Container Type:</b> {{ row4.item.JobTContainerType }}</span>
                      </b-col>
                      <b-col md="3" class="mb-2" v-if="row4.item.RaisedFrom">
                        <span><b>Raised From:</b> {{ row4.item.RaisedFrom }}</span>
                      </b-col>
                      <b-col md="3" class="mb-2" v-if="row4.item.RaisedBy">
                        <span><b>Raised By:</b> {{ row4.item.RaisedBy }}</span>
                      </b-col>
                      <b-col md="3" class="mb-2" v-if="row4.item.HBL">
                        <span><b>HBL:</b> {{ row4.item.HBL }}</span>
                      </b-col>
                      <b-col md="3" class="mb-2" v-if="row4.item.MBL">
                        <span><b>MBL:</b> {{ row4.item.MBL }}</span>
                      </b-col>
                      <b-col md="3" class="mb-2" v-if="row4.item.HBL">
                        <span><b>HBL:</b> {{ row4.item.HBL }}</span>
                      </b-col>
                      <b-col md="3" class="mb-2" v-if="row4.item.MBLDate">
                        <span><b>MBL Date:</b> {{ row4.item.MBLDate }}</span>
                      </b-col>
                      <b-col md="3" class="mb-2" v-if="row4.item.MBLReleaseDate">
                        <span><b>MBL Release Date:</b> {{ row4.item.MBLReleaseDate }}</span>
                      </b-col>
                      <b-col md="3" class="mb-2" v-if="row4.item.ExpClientName">
                        <span><b>Exp Client Name:</b> {{ row4.item.ExpClientName }}</span>
                      </b-col>
                      <b-col md="3" class="mb-2" v-if="row4.item.ImpClientName">
                        <span><b>Imp Client Name:</b> {{ row4.item.ImpClientName }}</span>
                      </b-col>
                      <b-col md="3" class="mb-2" v-if="row4.item.POD">
                        <span><b>POD:</b> {{ row4.item.POD }}</span>
                      </b-col>
                      <b-col md="3" class="mb-2" v-if="row4.item.FPOD">
                        <span><b>FPOD:</b> {{ row4.item.FPOD }}</span>
                      </b-col>
                      <b-col md="3" class="mb-2" v-if="row4.item.PICK">
                        <span><b>PICK:</b> {{ row4.item.PICK }}</span>
                      </b-col>
                      <b-col md="3" class="mb-2" v-if="row4.item.STUFF">
                        <span><b>STUFF:</b> {{ row4.item.STUFF }}</span>
                      </b-col>
                      <b-col md="3" class="mb-2" v-if="row4.item.HAND">
                        <span><b>HAND:</b> {{ row4.item.HAND }}</span>
                      </b-col>
                    </b-row>
                  </b-card>
                </template>


              </b-table>
            </div>
            <div>
              <b-pagination limit="25" align="center" v-model="pagination.currentPage" :per-page="pagination.perPage"
                :total-rows="totalData" @change="onPageChange($event)"></b-pagination>
            </div>
          </div>
        </div>
      </b-card-text>
    </b-card>
    <b-modal id="confirm-bulk-payment" ref="confirm-bulk-payment" title="Confirm Bulk Payment" size="lg" no-close-on-esc
      no-close-on-backdrop hide-footer>
      <b-row>
        <b-col md="12">
          <h5>Are you sure you want to proceed with bulk payment?</h5>
        </b-col>
      </b-row>
      <b-card v-if="excelRows.length <= 0 && selectedCheckBoxRows.length > 0">
        <b-card-body>

          <b-row>
            <b-col cols="12">
              <h4 class="mt-3 error" v-if="errMSG">{{ errMSG }} </h4>
            </b-col>
            <b-col cols="4">
              <model-list-select :isDisabled="true" :list="payList" v-model="payment.paymentMode" option-value="payVal"
                option-text="payText" placeholder="Select Payment Mode"
                :style="{ borderColor: !payment.paymentMode && errorCustomPaymentValidation.paymentMode ? 'red' : '' }"></model-list-select>
              <span class="error" v-if="!payment.paymentMode">{{ errorCustomPaymentValidation.paymentMode }}</span>
            </b-col>
            <b-col cols="4">
              <b-form-input :formatter="capitalizeAll" name="paymentAmount" id="paymentAmount"
                placeholder="Enter Payment Amount" v-model="payment.paymentAmount"
                :style="{ borderColor: !payment.paymentAmount && errorCustomPaymentValidation.paymentAmount ? 'red' : '' }" />
              <span class="error" v-if="!payment.paymentAmount">{{ errorCustomPaymentValidation.paymentAmount }}</span>
            </b-col>
            <b-col cols="4">
              <b-form-input :formatter="capitalizeAll" placeholder="Enter Payment Reference No" id="paymentRef"
                name="paymentRef" v-model="payment.paymentRef"
                :style="{ borderColor: !payment.paymentRef && errorCustomPaymentValidation.paymentRef ? 'red' : '' }" />
              <span class="error" v-if="!payment.paymentRef">{{ errorCustomPaymentValidation.paymentRef }}</span>
            </b-col>
          </b-row>
          <b-row>
            <b-col cols="4">
              <date-picker :format="selectDateFormat" lang="en" placeholder="Enter Payment Date" name="paymentDate"
                id="paymentDate" v-model="payment.paymentDate" :minute-step="1"
                :style="{ borderColor: !payment.paymentDate && errorCustomPaymentValidation.paymentDate ? 'red' : '' }" />
              <span class="error" v-if="!payment.paymentDate">{{ errorCustomPaymentValidation.paymentDate }}</span>
            </b-col>
            <b-col md="8" class=" mt-2" v-if="selectedCheckBoxRows.length > 0">
              <b-button class="mr-2 btn-sm" variant="primary" @click="handleConfirmOk"
                :disabled="selectedCheckBoxRows.length <= 0">

                <span v-if="!isBulkPaymentProcessing">Bulk Payment</span>
                <span v-else>
                  <b-spinner small class="mr-2"></b-spinner>
                  Processing...
                </span>
              </b-button>
              <b-button class="mr-2 btn-sm" variant="outline-danger" @click="resetModal">
                Cancel
              </b-button>
            </b-col>
          </b-row>
        </b-card-body>
      </b-card>
      <b-row>
        <b-col cols="12">
          <h4 class="mt-3 error" v-if="errMSG && excelRows.length > 0">{{ errMSG }} </h4>
        </b-col>
        <b-col md="12" v-if="selectedCheckBoxRows.length > 0">
          <b-table :items="selectedCheckBoxRows" :fields="confirmFields" small responsive head-variant="light">
            <template slot="SN" slot-scope="row0"><span>{{ row0.index + 1 }}</span></template>
          </b-table>
        </b-col>
        <b-col md="12" v-else-if="excelRows.length > 0">
          <b-table :items="excelRows" :fields="confirmExcelFields" small responsive head-variant="light">
            <template slot="SN" slot-scope="row0"><span>{{ row0.index + 1 }}</span></template>
          </b-table>
        </b-col>
        <b-col md="12" class=" mt-2" v-if="excelRows.length > 0">
          <b-button class="mr-2 btn-sm" variant="primary" @click="getSlineImportData" :disabled="excelRows.length <= 0">

            <span v-if="!isBulkPaymentProcessing">Bulk Payment</span>
            <span v-else>
              <b-spinner small class="mr-2"></b-spinner>
              Processing...
            </span>
          </b-button>
          <b-button class="mr-2 btn-sm" variant="outline-danger" @click="resetModal">
            Cancel
          </b-button>
        </b-col>

      </b-row>

      <!-- You could also include item details here if needed -->
    </b-modal>
    <md-dialog-alert :md-content="alert.content" :md-ok-text="alert.ok" ref="addPop"></md-dialog-alert>
  </div>
</template>

<script>
import DatePicker from "vue2-datepicker";
import CustomLoader from "../common/customLoader.vue";
import { DateFormat, selectDateFormat, excelSerialToDate } from "../../helper/filters";
import { lastVisitPage, globalPermissionStatus } from "../../helper/collection";
import DateRangePicker from "vue2-daterange-picker";
import NodeLockPannelService from "../../services/NodeLockPannelService";
import { ModelListSelect, MultiSelect } from "vue-search-select";
import Multiselect from "vue-multiselect";
import { URL_BASE, URL_BASE_DOC } from "../../helper/constant";
import { read, utils, writeFile } from "xlsx";

export default {
  // Component logic for Tab 1
  beforeMount() {
    lastVisitPage(this.$router.history.current.fullPath);

    const storePromises = [
      this.$store.dispatch(
        "common/setAllUserList",
        JSON.stringify({
          itemCode: "GET_USERLIST_Data",
        })
      ),
      this.$store.dispatch(
        "common/setAllBranchList",
        JSON.stringify({
          filter: "BranchList",
          active: "all",
        })
      ),
      this.$store.dispatch("common/setAllAgentColoaderList"),
      this.$store.dispatch(
        "common/setAllClientList",
        JSON.stringify({ itemCode: "ClientList" })
      ),
      this.$store.dispatch(
        "common/setAllShippingLineList",
        JSON.stringify({ itemCode: "ShippingLineList" })
      ),
      this.$store.dispatch(
        "common/setAllLocationDetailsFinalList",
        JSON.stringify({ itemCode: "LocationDetailsFinalList" })
      ),
      this.$store.dispatch(
        "common/setAllPORList",
        JSON.stringify({ itemCode: "PORList" })
      ),
      this.$store.dispatch(
        "common/setAllPODList",
        JSON.stringify({ itemCode: "PODList" })
      ),
      this.$store.dispatch(
        "common/setAllPOLList",
        JSON.stringify({ itemCode: "POLList" })
      ),

      this.$store.dispatch(
        "common/setAllCurrencyList",
        JSON.stringify({ Currency: "Currency_DropDown" })
      ),

    ];
    // Function to introduce a delay
    const delay = (ms) => new Promise((resolve) => setTimeout(resolve, ms));
    // Wait for all store actions to complete
    Promise.all(storePromises)
      .then(() => delay(5000)) // Wait for 5 seconds
      .then(() => {
        // After the delay, execute the next function

      })
      .catch((error) => {
        console.error("Error dispatching store actions:", error);
      });

    this.$store.dispatch("setCurrentRoute", this.$router.history.current.fullPath);
    this.getCurrentLastDate();

    if (this.lastVisitPage && this.$sessionsStorage.get("lastVisitPage")) {
      this.fetchLastPage(this.lastVisitPage);
    } else {
      this.getBulkSlinePaymentList("Normal", "0", "0", "1", "1");
    }
  },
  mounted() { },
  filters: {
    moment(date) {
      return DateFormat(date);
    },
  },

  beforeDestroy() { },

  destroyed() { },
  data() {
    return {
      errMSG: "",
      docURL: URL_BASE_DOC,
      selectDateFormat,
      lastVisitPage: this.$sessionsStorage.get("lastVisitPage"),
      ExcelBtnName: "Export As Excel",
      ExcelBtnName1: "Export And Import",
      visible: false,
      getPaymentList: [],
      totalData: 0,

      payList: [
        {
          payVal: "1",
          payText: "RTGS",
        },
        {
          payVal: "2",
          payText: "Cheque",
        },
      ],
      payment: {
        paymentMode: "1",
        paymentAmount: "",
        paymentRef: "",
        paymentDate: "",
      },

      errorCustomPaymentValidation: {
        paymentMode: "",
        paymentAmount: "",
        paymentRef: "",
        paymentDate: "",
      },

      arrayErrorCustomValidation: [
        {
          paymentMode: "Select Payment Mode",
          paymentAmount: "Enter Payment Amount",
          paymentRef: "Enter Payment Reference No",
          paymentDate: "Enter Payment Date",
        },
      ],
      validate: true,

      // Date format for datepickers
      confirmExcelFields: [
        { key: 'SN', label: 'SN' },
        { key: 'paymentModuleType', label: 'Module' },
        { key: 'JobNo', label: 'Job No.' },
        { key: 'InvNumber', label: 'Invoice No.' },
        { key: 'InvAmt', label: 'Amount' },
        { key: 'payReference', label: 'Pay Reference' },
        { key: 'paidAmount', label: 'Pay Amount' },
        { key: 'payDate', label: 'Pay Date' },
      ],
      excelRows: [],
      dateFormat: { year: "numeric", month: "short", day: "numeric" },
      confirmFields: [
        { key: 'SN', label: 'SN' },
        { key: 'paymentModuleType', label: 'Module' },
        { key: 'JobNo', label: 'Job No.' },
        { key: 'InvNumber', label: 'Invoice No.' },
        { key: 'InvAmt', label: 'Amount' }
      ],
      isBulkPaymentProcessing: false,
      selectedCheckBoxRows: [],
      PaymentFields: [
        {
          key: 'checkbox',   // Our custom field name for checkboxes
          mainkey: "checkbox",
          label: 'Select',         // No label, or you can put "Select"
          sortable: false,
          sortDirection: "ASC",
          table: "A.",
        },
        {
          key: "SN",
          mainkey: "SN",
          label: "SN.",
          sortable: true,
          sortDirection: "ASC",
          table: "A.",
        },

        {
          key: "invoiceNumber",
          mainkey: "invoiceNumber",
          label: "Inv Det.",
          sortable: true,
          sortDirection: "ASC",
          table: "C.",
        },
        {
          key: "JobNo",
          mainkey: "JobNo",
          label: "Job Det.",
          sortable: true,
          sortDirection: "ASC",
          table: "C.",
        },
        {
          key: "ClientName",
          mainkey: "ClientName",
          label: "Client/Sline Det.",
          sortable: true,
          sortDirection: "ASC",
          table: "C.",
        },
        {
          key: "POR",
          mainkey: "POR",
          label: "Loc Det.",
          sortable: true,
          sortDirection: "ASC",
          table: "C.",
        },

        {
          key: "EnqNo",
          mainkey: "EnqNo",
          label: "Enq Det.",
          sortable: true,
          sortDirection: "ASC",
          table: "C.",
        },
        //   {
        //     key: "paymentCreatedDate",
        //     mainkey: "paymentCreatedDate",
        //     label: "Action",
        //     sortable: true,
        //     sortDirection: "ASC",
        //     table: "C.",
        //   },
      ],

      pagination: {
        currentPage: 1,
        perPage: 50,
        pageOptions: [5, 10, 15],
      },
      sortBy: null,
      sortDesc: false,
      sortDirection: "asc",
      filter: null,

      statusList: [
        {
          pTypeVal: "0",
          pTypeText: "In-Active",
        },
        {
          pTypeVal: "1",
          pTypeText: "Active",
        },
        {
          pTypeVal: "2",
          pTypeText: "All",
        },
      ],
      shipmentTypeList: [
        {
          text: "Sea",
          value: "Sea",
        },
        {
          text: "Air",
          value: "Air",
        },
      ],
      transportTypeList: [
        {
          text: "EXPORT",
          value: "EXPORT",
        },
        {
          text: "IMPORT",
          value: "IMPORT",
        },
        {
          text: "CROSS COUNTRY",
          value: "CRC",
        },
      ],
      dateTypeList: [
        {
          text: "Job",
          value: "1",
        },
        {
          text: "Payment Request Date",
          value: "2",
        },
      ],
      Filter: {
        DateTypeFilter: "2",
        JobNoFilter: "",
        clientFilter: "",
        slineFilter: "",
        TransportTypeFilter: "",
        ShipemntTypeFilter: "",
        PORFilter: "",
        POLFilter: "",
        PODFilter: "",
        FPODFilter: "",
        statusFilter: "2",
        commonFilter: "",
        createdByFilter: "",
        branchFilter: "",
        dateRange: {
          startDate: "",
          endDate: "",
        },
        startDate: "",
        endDate: "",
      },
      //Added By Priyanshu Singh Multi Select Start

      openLeft: "left",
      showCal: false,
      startDate: "2017-09-05",
      endDate: "2017-09-15",
      dateRange: {
        startDate: "",
        endDate: "",
      },
      locale: {
        direction: "ltr",
        format: "mm/dd/yyyy",
        separator: " - ",
        applyLabel: "Apply",
        cancelLabel: "Cancel",
        weekLabel: "W",
        customRangeLabel: "Custom Range",
        daysOfWeek: ["Sun", "Mon", "Tue", "Wed", "Thu", "Fri", "Sat"],
        monthNames: [
          "Jan",
          "Feb",
          "Mar",
          "Apr",
          "May",
          "Jun",
          "Jul",
          "Aug",
          "Sep",
          "Oct",
          "Nov",
          "Dec",
        ],
        firstDay: 0,
      },
      alert: {
        content: "Are you sure you want to delete ..!",
        ok: "ok",
      },
      value1: [new Date(2019, 9, 8), new Date(2019, 9, 19)],
      value2: [],
      langType: {
        pickers: ["Today", "Yesterday", "This Month", "This Year"],
      },
      time: "",
      date: "",
      week: ["SUN", "MON", "TUE", "WED", "THU", "FRI", "SAT"],

      langEnq: {
        pickers: ["", "", "previous 7 days", "previous 30 days"],
      },
      isLoading: false,
      generateExcel: "0",
      ExpImpType: "0",
      isSubmited: false,
      isFileLoading: false,
    };
  },

  components: {
    CustomLoader,
    DatePicker,
    ModelListSelect,
    DateRangePicker,

    MultiSelect,
    Multiselect,
  },
  computed: {
    // If number of selected rows = total rows in getPaymentList
    allSelected() {
      return this.selectedCheckBoxRows.length === this.getPaymentList.length;
    }
  },
  watch: {},
  methods: {
    triggerFileInput() {
      this.$refs.fileInput.click();
    },
    handleFileUpload(event) {
      const file = event.target.files[0];
      if (!file) return;

      const reader = new FileReader();
      this.isFileLoading = true;

      reader.onload = (e) => {
        const workbook = read(e.target.result, { type: 'binary' });

        const firstSheetName = workbook.SheetNames[0];
        const worksheet = workbook.Sheets[firstSheetName];

        const jsonData = utils.sheet_to_json(worksheet, { header: 1 });

        if (jsonData.length) {
          const headers = jsonData[0].map(header => header.replace(/\s+/g, '_'));

          const formattedData = jsonData.slice(1).map(row => {
            const rowData = {};
            headers.forEach((header, index) => {
              if (header == 'invoiceNumber') {
                rowData['InvNumber'] = row[index] || "";
              }
              if (header == 'amount') {
                rowData['InvAmt'] = row[index] || "";
              }

              rowData[header] = row[index] || "";
              if (header == 'payDate') {
                rowData['payDate'] = excelSerialToDate(row[index])
              }
            });
            return rowData;
          });

          setTimeout(() => {
            this.excelData = formattedData;
            this.excelRows = formattedData;
            this.openConfirmModal();
            this.isFileLoading = false;
          }, 1500);

        } else {
          this.isFileLoading = false;
        }
      };

      reader.readAsBinaryString(file);
    },
    getSlineImportData() {
      this.errMSG = "";
      if (this.excelRows.length > 20 && this.excelRows.length <= 2) {
        this.alert.content = "Please select maximum 20 invoices for bulk payment";
        this.errMSG = "Please select maximum 20 invoices for bulk payment";
        // this.$refs["addPop"].open();
        return false;
      }
      if (this.excelRows.length > 0) {
        this.isBulkPaymentProcessing = true;
        NodeLockPannelService.excelBulkPaymentJob({ excel_data: this.excelRows })
          .then((response) => {
            const { data, status, statusText } = response;

            if (status == 200 && data) {
              this.isBulkPaymentProcessing = false;
              this.excelRows = [];
              this.resetModal();
              this.getBulkSlinePaymentList("Normal", "0", "0", "1", "1");
            }
            this.isLoading = false;
          })
          .catch((error) => {
            console.log("Catch on getSlineImportData Error: ", error);
          });
      } else {
        console.log("PLease Choose Atleast One Correct Ledger List ");
      }
    },
    validatePaaymentCustomValidation() {
      let validate_new = true;
      Object.keys(this.errorCustomPaymentValidation).map((x, index) => {
        if (
          this.payment[x] == "" ||
          this.payment[x] == 0 ||
          this.payment[x] == undefined ||
          this.payment[x] == null ||
          this.payment[x] == "undefined" ||
          this.payment[x] == "null"
        ) {
          this.errorCustomPaymentValidation[x] = this.arrayErrorCustomValidation[0][x];
          validate_new = false;
        }
      });

      if (validate_new == true) {
        this.validate = true;
      } else {
        this.validate = false;
      }
    },
    toggleSelectAll(checked) {
      if (checked) {
        // Select all rows -> store only the 3 keys in each object
        this.selectedCheckBoxRows = this.getPaymentList.map(item => ({
          paymentModuleType: item.paymentModuleType,
          invoicePayID: item.invoicePayID,
          invoiceID: item.invoiceID,
          invoiceAmtID: item.invoiceAmtID,
          JobId: item.JobId,
          JobNo: item.JobNo,
          InvNumber: item.invoiceNumber,
          InvAmt: item.amount,
        }));

      } else {
        // Clear selection
        this.selectedCheckBoxRows = [];
      }
    },
    openConfirmModal() {
      this.$refs["confirm-bulk-payment"].show();
    },
    async handleConfirmOk() {
      this.errMSG = "";
      if (this.selectedCheckBoxRows.length > 20 && this.selectedCheckBoxRows.length <= 2) {
        this.alert.content = "Please select maximum 20 invoices for bulk payment";
        this.errMSG = "Please select maximum 20 invoices for bulk payment";
        // this.$refs["addPop"].open();
        return false;
      }
      this.validatePaaymentCustomValidation();
      
      if (this.validate == true) {
        if (this.selectedCheckBoxRows.length <= 0) return;
        try {
          this.isBulkPaymentProcessing = true;
          await this.bulkPayment(this.selectedCheckBoxRows);
        } catch (err) {
          console.error("Bulk payment failed:", err);
        } finally {
          this.isBulkPaymentProcessing = false;
        }
      }
    },
    resetModal() {
      // Reset state each time modal is closed
      this.selectedCheckBoxRows = [];
      this.errMSG = "";
      this.$refs["confirm-bulk-payment"].hide();
    },

    async bulkPayment() {
      try {

        if (!this.selectedCheckBoxRows || this.selectedCheckBoxRows.length === 0) {
          console.error("No selected invoices for payment.");
          return;
        }

        const response = await NodeLockPannelService.bulkPaymentJob({ invoices: this.selectedCheckBoxRows, payment: this.payment }, {})

        // Handle API response
        if (response.data.status) {
          this.resetModal();
          this.getBulkSlinePaymentList("Normal", "0", "0", "1", "1");
          console.info(response.data.message || "Bulk payment processed successfully.");
        } else {
          console.error(response.data.message || "Bulk payment failed.");
        }

      } catch (error) {
        console.error("Bulk Payment Error:", error);
        console.error("An error occurred while processing bulk payment.");
      } finally {
        this.isBulkPaymentProcessing = false; // Hide loading indicator
      }
    },

    clearFilter() {
      this.Filter = {
        DateTypeFilter: "2",
        JobNoFilter: "",
        clientFilter: "",
        slineFilter: "",
        TransportTypeFilter: "",
        ShipemntTypeFilter: "",
        PORFilter: "",
        POLFilter: "",
        PODFilter: "",
        FPODFilter: "",
        statusFilter: "2",
        commonFilter: "",
        createdByFilter: "",
        branchFilter: "",
        dateRange: {
          startDate: "",
          endDate: "",
        },
        startDate: "",
        endDate: "",
      };
      this.getBulkSlinePaymentList("Normal", "0", "0", "1", "1");
    },
    getCurrentLastDate() {
      var today = new Date();

      // Subtract 1 day from today to get the previous day
      var previousDay = new Date();
      previousDay.setDate(today.getDate() - 1);

      // Format yesterday's date (DD/MM/YYYY)
      var prev_dd = String(previousDay.getDate()).padStart(2, "0");
      var prev_mm = String(previousDay.getMonth() + 1).padStart(2, "0");
      var prev_yyyy = previousDay.getFullYear();
      var startDate = `${prev_yyyy}/${prev_mm}/${prev_dd}`; // 11/02/2025

      // Format today's date (DD/MM/YYYY)
      var today_dd = String(today.getDate()).padStart(2, "0");
      var today_mm = String(today.getMonth() + 1).padStart(2, "0");
      var today_yyyy = today.getFullYear();
      var endDate = `${today_yyyy}/${today_mm}/${today_dd}`; // 12/02/2025

      // Set startDate and endDate
      this.startDate = startDate;
      this.Filter.dateRange = {
        startDate: startDate, // 11/02/2025
        endDate: endDate,     // 12/02/2025
      };
    },


    getCurrentLastDateBak() {
      var today = new Date();
      var firstDay = new Date(today.getFullYear(), today.getMonth(), 1);
      var lastDay = new Date(today.getFullYear(), today.getMonth() + 1, 0);

      var firstDay_dd = String(firstDay.getDate()).padStart(2, "0");
      var firstDay_mm = String(firstDay.getMonth() + 1).padStart(2, "0"); //January is 0!
      var firstDay_yyyy = firstDay.getFullYear();

      var lastDay_dd = String(lastDay.getDate()).padStart(2, "0");
      var lastDay_mm = String(lastDay.getMonth() + 1).padStart(2, "0"); //January is 0!
      var lastDay_yyyy = lastDay.getFullYear();

      firstDay = firstDay_yyyy + "/" + firstDay_mm + "/" + firstDay_dd; //2018-06-01
      lastDay = lastDay_yyyy + "/" + lastDay_mm + "/" + lastDay_dd; //2018-06-01

      var dd = String(today.getDate()).padStart(2, "0");
      var mm = String(today.getMonth() + 1).padStart(2, "0"); //January is 0!
      var yyyy = today.getFullYear();
      today = yyyy + "/" + mm + "/" + dd; //2018-06-01
      this.startDate = today;
      this.Filter.dateRange = {
        startDate: firstDay,
        endDate: lastDay,
      };
    },

    getBulkSlinePaymentList(type, filterIdD, CURRENT, SEARCH, pageNumber) {

      this.totalData = 0;
      this.getPaymentList = [];
      let payload = {};
      if (type == "Normal") {
        this.isLoading = true;
      }
      payload = {
        type: type,
        DCfilterId: filterIdD,
        searchVal: this.filter,
        DCfilterId: filterIdD,
        fromSearch: SEARCH,
        // currentPage: CURRENT,
        currentPage: this.pagination.currentPage,
        page: this.pagination.currentPage,
        perPage: this.pagination.perPage,
        pageSize: this.pagination.perPage,
        filter: this.Filter,
        generateExcel: this.generateExcel,
        ExpImpType: this.ExpImpType,
      };
      // Set responseType to 'blob' if generating Excel
      const config = this.generateExcel == "1" ? { responseType: "blob" } : {};
      NodeLockPannelService.getAllBulkPaymentJobList(payload, config)
        .then((response) => {
          const { data, status, statusText } = response;
          if (status == 200 && data) {
            if (this.generateExcel == "1") {
              // Handle file download
              const blob = new Blob([data], {
                type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
              });
              const url = window.URL.createObjectURL(blob);
              const link = document.createElement("a");
              link.href = url;
              link.setAttribute("download", "get-Sales-Payment-panel-report.xlsx"); // Specify the file name
              document.body.appendChild(link);
              link.click();
              document.body.removeChild(link);

              this.ExcelBtnName = "Export As Excel";
              this.ExcelBtnName1 = "Export And Import";
              this.generateExcel = "0";
              this.ExpImpType = "0";
              this.getBulkSlinePaymentList("Normal", "0", "0", "1", "1");
            } else {
              if (data.data.length > 0) {
                this.totalData = data.pagination.totalPaymentList;
                this.getPaymentList = data.data;
                this.pagination.totalRows = data.pagination.totalPaymentList;
                this.pagination.currentPage = data.pagination.currentPage;
                this.pagination.perPage = data.pagination.pageSize;
              }
            }
          }
          this.isLoading = false;
        })
        .catch((error) => {
          console.log("Catch on getPaymentList Error: ", error);
        });
    },
    onFiltered(filtered) {
      this.totalRows = filtered.length;
      this.pagination.currentPage = 1;
    },
    clearTimeout() { },
    goBack() {
      window.history.go(-1);
    },

    debounceSearch(event) {
      clearTimeout(this.debounce);
      this.debounce = setTimeout(() => {
        this.getBulkSlinePaymentList("Normal", "0", "0", "1", "1");
      }, 1000);
    },
    getReports(id, btnName) {
      this.isLoading = true;
      this.ExpImpType = "1";
      this.generateExcel = "1";
      this.ExcelBtnName = "Downloading Please Wait .....";
      this.getBulkSlinePaymentList("Excell", "0", "0", "1", "1");
    },
    getExpImpReports(id, btnName) {
      this.ExpImpType = "2";
      this.isLoading = true;
      this.generateExcel = "1";
      this.ExcelBtnName1 = "Downloading Please Wait .....";
      this.getBulkSlinePaymentList("Excell", "0", "0", "1", "1");
    },
    fetchLastPage(event) {
      let CURRENT = 0;
      if (event == "1") {
        CURRENT = 0;
      } else {
        CURRENT = parseInt(event) * this.pagination.perPage - this.pagination.perPage;
      }
      this.getBulkSlinePaymentList("Normal", "0", CURRENT, "2", event);
    },
    onPageChange: function (event) {
      this.pagination.currentPage = event;
      this.$sessionsStorage.set("lastVisitPage", event);
      this.$sessionsStorage.set("oldRoute", this.$router.history.current.fullPath);
      let CURRENT = 0;
      if (event == "1") {
        CURRENT = 0;
      } else {
        CURRENT = event * this.pagination.perPage - this.pagination.perPage;
      }
      this.getBulkSlinePaymentList("Normal", "0", CURRENT, "2", event);
    },
  },
};
</script>


// WEBPACK FOOTER //
// slineBulkPayment.vue?515b3219